import React from 'react';
import Button from '../Button';
import { TimesIcon } from '../Icons';
import { useTranslation } from 'react-i18next';
import { saveToStore } from 'utils/storeHelpers';
import { URLS } from 'configs';
import { sendEvent } from 'utils/analyticsHelpers';

const ReminderMobileModal = ({ onClose, className }) => {
  const { t } = useTranslation();

  const handleConfirmClick = () => {
    window.open(URLS.APP_STORE, '_blank');
    sendEvent('open_link', { method: 'appstore' });
    onClose();
  };

  const onCancel = () => {
    saveToStore('mobile_reminder', true);
    onClose();
  };

  return (
    <div className={`reminder-modal mx-4 d-flex flex-column justify-content-between px-10 py-15 ${className}`}>
      <button className='btn p-0 modal-close' onClick={onClose}>
        <TimesIcon />
      </button>
      <h2 className='mb-8'>{t('get_ios_app_title')}</h2>
      <p className='mb-12'>{t('get_ios_app_desc')}</p>
      <div className='d-flex align-items-center'>
        <Button type='button' className={'btn-sm mr-12 bg-white border-primary text-primary'} onClick={onCancel}>
          {t('btn_dont_show_again')}
        </Button>
        <Button type='button' onClick={handleConfirmClick} className={'btn-sm px-md-10 btn-primary'}>
          {t('btn_get_ios_app')}
        </Button>
      </div>
    </div>
  );
};

export default ReminderMobileModal;
